module.exports = __webpack_public_path__ + "src/img/artist/work07_1.jpg?15a6509cfbd23600940e2e9a1d66415e";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work07_1.jpg
// module id = 24
// module chunks = 0